export default "__VITE_ASSET__BIdwo2dZ__"